import { css } from '@emotion/react';

import { colors } from './colors';
import { BaseFont } from './font';
import { MediaBP as MQ } from './mediaQuery';

type FlexDirections =
  | 'row'
  | 'row-reverse'
  | 'column'
  | 'column-reverse'
  | 'inherit'
  | 'initial'
  | 'revert'
  | 'revert-layer'
  | 'unset';

type JustifyContent =
  | 'center'
  | 'start'
  | 'end'
  | 'flex-start'
  | 'flex-end'
  | 'left'
  | 'right'
  | 'normal'
  | 'space-between'
  | 'space-around'
  | 'space-evenly'
  | 'stretch'
  | 'safe center'
  | 'unsafe center'
  | 'inherit'
  | 'initial'
  | 'revert'
  | 'revert-layer'
  | 'unset'
  | ''
  | null
  | undefined;
type AlignItems =
  | 'normal'
  | 'stretch'
  | 'center'
  | 'start'
  | 'end'
  | 'flex-start'
  | 'flex-end'
  | 'self-start'
  | 'self-end'
  | 'anchor-center'
  | 'baseline'
  | 'first baseline'
  | 'last baseline'
  | 'safe center'
  | 'unsafe center'
  | 'inherit'
  | 'initial'
  | 'revert'
  | 'revert-layer'
  | 'unset'
  | ''
  | null
  | undefined;

export const flex = (
  flexDirection: FlexDirections = 'row',
  justifyContent: JustifyContent = 'center',
  alignItems: AlignItems = 'center'
) => css`
  display: flex;
  flex-direction: ${flexDirection};
  justify-content: ${justifyContent};
  align-items: ${alignItems};
`;

export const setProperty = (styles: string) =>
  css`
    ${styles}
  `;

export const setFontSizeLineHeightRem = (
  fontsize?: number | undefined,
  lineHeight?: number | undefined
) => css`
  ${fontsize &&
  css`
    font-size: ${fontsize / BaseFont}rem;
  `}
  ${lineHeight &&
  css`
    line-height: ${lineHeight / BaseFont}rem;
  `}
`;

export const BorderRadius = '6px';

/* ASPECT RATIO */

export const AspectRatio = (width: number, height: number) => css`
  position: relative;

  &:before {
    display: block;
    content: ' ';
    width: 100%;
    // padding-top: ${(width / height) * 100}%;
  }

  & .content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
`;

export const TemplateLoaderCardBg = css`
  background: linear-gradient(
    283.97deg,
    ${colors.TemplateLoaderTrayBgLight} 0%,
    ${colors.TemplateLoaderTrayBgDark} 100%
  );

  ${MQ.MediaLg} {
    background: ${colors.TemplateLoaderTrayBgDesktop};
  }
`;

export const PlaceholderImg = (
  width: number,
  height: number,
  imgurl: string
) => css`
  ${AspectRatio(width, height)};
  width: 100%;

  ${width <= height
    ? `
    &.content {
      ${TemplateLoaderCardBg};
      border-radius: ${BorderRadius};

      &.animate {
        z-index: 0;
        overflow: hidden;
        &:after {
          content: '';
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          z-index: 0;
          background: ${colors.TemplateLoaderTrayBgDesktop};
          background-image: linear-gradient(
            90deg,
            ${colors.PrimaryWhiteColorAlpha0} 0%,
            ${colors.PrimaryBlackColorAlpha20} 35%,
            ${colors.PrimaryBlackColorAlpha20} 65%,
            ${colors.PrimaryWhiteColorAlpha0} 100%
          );
          background-repeat: no-repeat;
          background-size: 100%;
          display: inline-block;
          animation: shine-lines 0.8s infinite linear;
        }
      }

      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-size: 50%;
      }
      & .errImgDisplay[alt]:after {
        opacity: 0;
        content: attr(alt);
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-size: 50%;
        background-image: url(${imgurl});
        background-repeat: no-repeat;
        background-position: center;
        background-color: ${colors.TemplateLoaderTrayBgDesktop};
        padding: 10px;
        font-size: 10px;
        text-indent: -1000px;
        visibility: visible;
      }
    }
  `
    : `
    &.content {
      ${TemplateLoaderCardBg};
      border-radius: ${BorderRadius};

      &.animate {
        overflow: hidden;
        z-index: 0;
        &:after {
          content: '';
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          z-index: 0;
          background: ${colors.TemplateLoaderTrayBgDesktop};
          background-image: linear-gradient(
            90deg,
            ${colors.PrimaryWhiteColorAlpha0} 0%,
            ${colors.PrimaryBlackColorAlpha20} 35%,
            ${colors.PrimaryBlackColorAlpha20} 65%,
            ${colors.PrimaryWhiteColorAlpha0} 100%
          );
          background-repeat: no-repeat;
          background-size: 100%;
          display: inline-block;
          animation: shine-lines 0.8s infinite linear;
        }
      }

      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-size: auto 50%;
      }
      .errImgDisplay[alt]:after {
        opacity: 0;
        content: attr(alt);
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-size: auto 50%;
        background-image: url(${imgurl});
        background-repeat: no-repeat;
        background-position: center;
        background-color: ${colors.TemplateLoaderTrayBgDesktop};
        padding: 10px;
        font-size: 10px;
        text-indent: -1000px;
        visibility: visible;
      }
    }
  `}
`;
